module.exports = __webpack_public_path__ + "static/microsoft-sql-server-54d7bddcd3019ec3c3b23db00160ccef.svg";